import { Injectable, inject } from '@angular/core';
import { SessionStore } from '../auth/session.store';
import { type PermissionRequirement } from './permission-catalog';

/**
 * Answers "does the signed-in user hold this permission?" from the session. The answer is
 * read from a signal, so a template, `computed` or `effect` that calls `has()` updates when
 * the session changes.
 *
 * This is a convenience for the UI. The API checks every request again; hiding a button
 * never replaces the server's check.
 */
@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly session = inject(SessionStore);

  /**
   * True when the user holds the permission, or, for an array, any one of them. An empty
   * array is false: a requirement with nothing in it grants nothing.
   */
  has(required: PermissionRequirement): boolean {
    const held = this.session.permissions();
    const wanted: readonly string[] = typeof required === 'string' ? [required] : required;
    return wanted.some((permission) => held.has(permission));
  }
}
